import axios from 'axios';
import { api } from '../utils/index';

export const FETCH_REPORTS_BEGIN = 'FETCH_REPORTS_BEGIN';
export const FETCH_REPORTS_SUCCESS = 'FETCH_REPORTS_SUCCESS';
export const FETCH_REPORTS_FAILURE = 'FETCH_REPORTS_FAILURE';
export const CREATE_REPORT_BEGIN = 'CREATE_REPORT_BEGIN';
export const CREATE_REPORT_SUCCESS = 'CREATE_REPORT_SUCCESS';
export const CREATE_REPORT_FAILURE = 'CREATE_REPORT_FAILURE';
export const UPDATE_REPORT_BEGIN = 'UPDATE_REPORT_BEGIN';
export const UPDATE_REPORT_SUCCESS = 'UPDATE_REPORT_SUCCESS';
export const UPDATE_REPORT_FAILURE = 'UPDATE_REPORT_FAILURE';
export const DELETE_REPORT_BEGIN = 'DELETE_REPORT_BEGIN';
export const DELETE_REPORT_SUCCESS = 'DELETE_REPORT_SUCCESS';
export const DELETE_REPORT_FAILURE = 'DELETE_REPORT_FAILURE';

function fetchReportsBegin() {
  return {
    type: FETCH_REPORTS_BEGIN
  };
}

function fetchReportsSuccess(reports) {
  return {
    type: FETCH_REPORTS_SUCCESS,
    payload: reports
  };
}

function fetchReportsFailure() {
  return {
    type: FETCH_REPORTS_FAILURE
  };
}

function createReportBegin() {
  return {
    type: CREATE_REPORT_BEGIN
  };
}

// function createReportSuccess(payload) {
//   return {
//     type: CREATE_REPORT_SUCCESS,
//     payload
//   };
// }

function createReportFailure() {
  return {
    type: CREATE_REPORT_FAILURE
  };
}

function updateReportBegin() {
  return {
    type: UPDATE_REPORT_BEGIN
  };
}

// function updateReportSuccess(payload) {
//   return {
//     type: UPDATE_REPORT_SUCCESS,
//     payload
//   };
// }

function updateReportFailure() {
  return {
    type: UPDATE_REPORT_FAILURE
  };
}

function deleteReportBegin() {
  return {
    type: DELETE_REPORT_BEGIN
  };
}

function deleteReportSuccess(payload) {
  return {
    type: DELETE_REPORT_SUCCESS,
    payload
  };
}

function deleteReportFailure() {
  return {
    type: DELETE_REPORT_FAILURE
  };
}

export function fetchReports() {
  return dispatch => {
    dispatch(fetchReportsBegin());
    return axios
      .get(`${api}v4/reporting/flexible`)
      .then(response => response.data)
      .then(reports => dispatch(fetchReportsSuccess(reports)))
      .catch(() => dispatch(fetchReportsFailure()));
  };
}

export function createReport(name, filters, archived) {
  return dispatch => {
    dispatch(createReportBegin());
    const form = { name, data: { filters, archived } };
    return axios
      .post(`${api}v4/reporting/flexible`, form)
      .then(response => response.data)
      .then(event => {
        // TODO: On BE create report should return report object with ID to pass on to reducer
        // dispatch(createReportSuccess({event}));
        dispatch(fetchReports());
        return event;
      })
      .catch(() => dispatch(createReportFailure()));
  };
}

export function updateReport(id, name, filters, archived) {
  return dispatch => {
    dispatch(updateReportBegin());
    const form = { name, data: { filters, archived } };
    return axios
      .patch(`${api}v4/reporting/flexible/${id}`, form)
      .then(response => response.data)
      .then(event => {
        // TODO: On BE create report should return report object with ID to pass on to reducer
        // dispatch(updateReportSuccess(event));
        dispatch(fetchReports());
        return event;
      })
      .catch(() => dispatch(updateReportFailure()));
  };
}

export function deleteReport(id) {
  return dispatch => {
    dispatch(deleteReportBegin());
    return axios
      .delete(`${api}v4/reporting/flexible/${id}`)
      .then(response => response.data)
      .then(event => {
        dispatch(deleteReportSuccess({ id, event }));
        return event;
      })
      .catch(() => dispatch(deleteReportFailure()));
  };
}
